module.exports = __webpack_public_path__ + "img/play_test_on.f92eba9e.png";